export default __webpack_public_path__ + "static/media/icon-mse.083e0931.svg";